module.exports = __webpack_public_path__ + "icon-projection.png?b2c20aeaab1ed95bf309f2a866964ea8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-projection.png
// module id = 65
// module chunks = 0